<template>
  <header class="hand-range-header panel-heading">
    <slot name="left-header"></slot>
    <span class="close" v-if="canBeRemoved" v-on:click="$emit('removePlayer')">&times;</span>
    <div class="dropdown">
      <button
        class="btn btn-default dropdown-toggle"
        data-toggle="dropdown"
        v-bind:disabled="disabled"
      >
        <span class="glyphicon glyphicon-menu-hamburger"></span>
      </button>
      <ul class="dropdown-menu">
        <li v-if="generalHands.numberOfSpecificHandsInRange > 0">
          <a v-on:click="expandSetHandWeightsModal()">Set hand weights <span class="glyphicon glyphicon-new-window"></span></a>
        </li>
        <li v-if="settingHandWeightsSetting === 'setWeightToApplyToAddedHandsModal'">
          <a v-on:click="expandSetWeightToApplyToAddedHandsModal()">Set weight to apply to added hands <span class="glyphicon glyphicon-new-window"></span></a>
        </li>
        <li v-if="!specificHandsNotAllowed">
          <a v-on:click="expandCombosToAddModal()">Select specific suits <span class="glyphicon glyphicon-new-window"></span></a>
        </li>
        <slot name="extra-dropdown-item-1"></slot>
      </ul>
    </div>
    <button
      class="clear btn btn-default"
      v-bind:disabled="disabled"
      v-on:click="$emit('clearRange')"
    >
      Clear
    </button>
    <a
      v-show="combosToAdd.length < 16"
      tabindex="0"
      class="glyphicon glyphicon-info-sign"
      data-toggle="popover"
      v-bind:data-content="combosToAddInfoText"
      data-placement="bottom"
      role="button"
      data-trigger="focus"
    ></a>
    <set-hand-weights-modal
      class="set-hand-weights-modal"
      v-bind:playerStateGeneralHands="generalHands"
      v-on:applyExactWeightToGeneralHands="$emit('applyExactWeightToGeneralHands', $event)"
    />
    <set-weight-to-apply-to-added-hands-modal
      class="set-weight-to-apply-to-added-hands-modal"
      v-bind:weightToApplyToAddedHands="weightToApplyToAddedHands"
      v-on:setWeightToApplyToAddedHands="$emit('setWeightToApplyToAddedHands', $event)"
    />
    <combos-to-add-modal
      class="combos-to-add-modal"
      v-bind:combosToAdd="combosToAdd"
      v-on:addComboToCombosToAdd="$emit('addComboToCombosToAdd', $event)"
      v-on:removeComboFromCombosToAdd="$emit('removeComboFromCombosToAdd', $event)"
    />
  </header>
</template>

<script>
import SetHandWeightsModal from '@/components/hand-range/hand-weight/set-hand-weights-modal';
import SetWeightToApplyToAddedHands from '@/components/hand-range/hand-weight/set-weight-to-apply-to-added-hands-modal';
import CombosToAddModal from '@/components/hand-range/modals/combos-to-add-modal';

export default {
  name: 'hand-range-header',
  components: {
    'set-hand-weights-modal': SetHandWeightsModal,
    'set-weight-to-apply-to-added-hands-modal': SetWeightToApplyToAddedHands,
    'combos-to-add-modal': CombosToAddModal,
  },
  props: ['generalHands', 'weightToApplyToAddedHands', 'combosToAdd', 'canBeRemoved', 'specificHandsNotAllowed', 'disabled'],
  computed: {
    settingHandWeightsSetting: function () {
      return this.$store.state.account.user.settings.general.visual.settingHandWeights;
    },
    combosToAddInfoText: function () {
      if (this.combosToAdd.length === 0) {
        return 'No combos are selected in the select specific suits menu.';
      }

      let text = 'When you click a hand, only the following combos will be added: ';

      this.combosToAdd.forEach(function (combo) {
        text += combo + ', ';
      });
      text = text.slice(0, -2);
      text += '. To change this, click the hamburger menu and then click "Select specific suits".';

      return text;
    },
  },
  mounted: function () {
    $('[data-toggle="popover"]').popover();
  },
  methods: {
    expandSetHandWeightsModal: function () {
      $(this.$el).find('.set-hand-weights-modal').modal();
    },
    expandSetWeightToApplyToAddedHandsModal: function () {
      $(this.$el).find('.set-weight-to-apply-to-added-hands-modal').modal();
    },
    expandCombosToAddModal: function () {
      $(this.$el).find('.combos-to-add-modal').modal();
    },
  },
};
</script>

<style lang="scss" scoped>
  .hand-range-header {
    min-height: 51px;
  }

  .dropdown {
    float: right;

    .glyphicon-new-window {
      color: grey;
    }

    ul.dropdown-menu {
      left: -120px;

      a {
        cursor: pointer;
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }
  }

  .glyphicon-info-sign {
    float: right;
    font-size: 16px;
    position: relative;
    top: 8px;
    right: 10px;
    cursor: pointer;
    color: inherit;

    &:hover {
      text-decoration: none;
    }
  }

  .close {
    position: relative;
    top: 5px;
    float: right;
    margin-left: 15px;
  }

  .clear {
    float: right;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/header.vue